import { render, staticRenderFns } from "./AutoRenewList.vue?vue&type=template&id=fbae7b0c"
import script from "./AutoRenewList.vue?vue&type=script&lang=js"
export * from "./AutoRenewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports